import dhtmlXGridObject from './dhtmlXGridObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlxArray from './dhtmlxArray';
import {Hashtable} from './dxGridComClass';
import goingEvent from '../../global/goingEvent';
import dragContext  from './dragContext';

dhtmlXGridObject.prototype._drag = function (s, h, r, u) {
    if (this._realfake) {
        return this._fake._drag();
    }
    var o = this.lastLanding;
    if (this._autoOpenTimer) {
        window.clearTimeout(this._autoOpenTimer);
    }
    var g = r.parentNode;
    var e = s.parentObject;
    if (!g.idd) {
        g.grid = this;
        this.dadmodefix = 0;
    }
    var n = new dragContext(0, 0, 0, g.grid.dadmode == 1 || g.grid.dadmodec ? "sibling" : "child");
    if (e && e.childNodes) {
        n.set("source", "tree")
            .set("sobj", e.treeNod)
            .set("sid", n.sobj._dragged);
    }
    else {
        if (!e) {
            return true;
        }
        if (e.treeNod.isTreeGrid && e.treeNod.isTreeGrid()) {
            n.set("source", "treeGrid");
        }
        n.set("sobj", e.treeNod).set("sid", n.sobj._dragged);
    }
    if (g.grid.isTreeGrid()) {
        n.set("target", "treeGrid");
    }
    else {
        n.set("dropmode", "sibling");
    }
    n.set("tobj", g.grid).set("tid", g.idd);
    if (n.tobj.dadmode == 2 && n.tobj.dadmodec == 1 && n.tobj.dadmodefix < 0) {
        if (n.tobj.obj.rows[1].idd != n.tid) {
            n.tid = g.previousSibling.idd;
        }
        else {
            if (this._h2 && n.tid) {
                n.before = true;
            }
            else {
                n.tid = 0;
            }
        }
    }
    var a = this.getFirstParentOfType(u, "TD");
    if (a) {
        n.set("tExtra", a._cellIndex);
    }
    if (a) {
        n.set("sExtra", n.sobj._dndExtra);
    }
    if (n.sobj.dpcpy) {
        n.set("mode", "copy");
    }
    if (n.tobj._realfake) {
        n.tobj = n.tobj._fake;
    }
    if (n.sobj._realfake) {
        n.sobj = n.sobj._fake;
    }
    n.tobj._clearMove();
    if (e && e.treeNod && e.treeNod._nonTrivialRow) {
        e.treeNod._nonTrivialRow(this, n.tid, n.dropmode, e);
    }
    else {
        n.tobj.dragContext = n;
        if (!n.tobj.callEvent("onDrag", [
            n.slist(),
            n.tid,
            n.sobj,
            n.tobj,
            n.sExtra,
            n.tExtra
        ])) {
            return (n.tobj.dragContext = null);
        }
        var v = new Array();
        if (typeof n.sid == "object") {
            var m = n.copy();
            for (var l = 0; l < n.sid.length; l++) {
                if (!m
                    .set("alfa", !l)
                    .set("sid", n.sid[l][n.source == "tree" ? "id" : "idd"])
                    .valid()) {
                    continue;
                }
                m.tobj._dragRoutine(m);
                if (m.target == "treeGrid" && m.dropmode == "child") {
                    m.tobj.openItem(m.tid);
                }
                v[v.length] = m.nid;
                m.set("dropmode", "sibling").set("tid", m.nid);
            }
            m.close();
        }
        else {
            n.tobj._dragRoutine(n);
        }
        if (n.tobj.laterLink) {
            n.tobj.laterLink();
        }
        n.tobj.callEvent("onDrop", [
            n.slist(),
            n.tid,
            v.join(","),
            n.sobj,
            n.tobj,
            n.sExtra,
            n.tExtra
        ]);
    }
    n.tobj.dragContext = null;
    n.close();
};
dhtmlXGridObject.prototype._dragRoutine = function (s) {
    if (s.sobj == s.tobj &&
        s.source == "grid" &&
        s.mode == "move" &&
        !this._fake) {
        if (s.sobj._dndProblematic) {
            return;
        }
        var o = s.sobj.rowsAr[s.sid];
        var r = s.sobj.rowsCol._dhx_find(o);
        s.sobj.rowsCol._dhx_removeAt(s.sobj.rowsCol._dhx_find(o));
        s.sobj.rowsBuffer._dhx_removeAt(s.sobj.rowsBuffer._dhx_find(o));
        s.sobj.rowsBuffer._dhx_insertAt(s.ind(), o);
        if (s.tobj._fake) {
            s.tobj._fake.rowsCol._dhx_removeAt(r);
            var u = s.tobj._fake.rowsAr[s.sid];
            u.parentNode.removeChild(u);
        }
        s.sobj._insertRowAt(o, s.ind() -
            (this.pagingOn ? (this.currentPage - 1) * this.rowsBufferOutSize : 0));
        s.nid = s.sid;
        s.sobj.callEvent("onGridReconstructed", []);
        return;
    }
    var n;
    if (this._h2 &&
        typeof s.tid != "undefined" &&
        s.dropmode == "sibling" &&
        (this._sbmod || s.tid)) {
        if (s.before) {
            n = s
                .uid()
                .tobj.addRowBefore(s.nid, s.data(), s.tid, s.img(), s.childs());
        }
        else {
            if (s.alfa && this._sbmod && this._h2.get[s.tid].childs.length) {
                this.openItem(s.tid);
                n = s
                    .uid()
                    .tobj.addRowBefore(s.nid, s.data(), this._h2.get[s.tid].childs[0].id, s.img(), s.childs());
            }
            else {
                n = s
                    .uid()
                    .tobj.addRowAfter(s.nid, s.data(), s.tid, s.img(), s.childs());
            }
        }
    }
    else {
        n = s
            .uid()
            .tobj.addRow(s.nid, s.data(), s.ind(), s.pid(), s.img(), s.childs());
    }
    n._attrs = s.attrs();
    var m = null;
    if (s.source == "tree") {
        this.callEvent("onRowAdded", [s.nid]);
        var a = s.sobj._globalIdStorageFind(s.sid);
        if (a.childsCount) {
            m = s
                .copy()
                .set("tid", s.nid)
                .set("dropmode", s.target == "grid" ? "sibling" : "child");
            for (var g = 0; g < a.childsCount; g++) {
                s.tobj._dragRoutine(m.set("sid", a.childNodes[g].id));
                if (s.mode == "move") {
                    g--;
                }
            }
            m.close();
        }
    }
    else {
        s.tobj._copyUserData(s);
        this.callEvent("onRowAdded", [s.nid]);
        if (s.source == "treeGrid") {
            if (s.sobj == s.tobj) {
                n._xml = s.sobj.rowsAr[s.sid]._xml;
            }
            var h = s.sobj._h2.get[s.sid];
            if (h && h.childs.length) {
                m = s.copy().set("tid", s.nid);
                if (s.target == "grid") {
                    m.set("dropmode", "sibling");
                }
                else {
                    if (!m.tobj.kidsXmlFile) {
                        m.tobj.openItem(s.tid);
                    }
                    m.set("dropmode", "child");
                }
                var e = h.childs.length;
                if (!m.tobj.kidsXmlFile) {
                    for (var g_1 = 0; g_1 < e; g_1++) {
                        s.sobj.render_row_tree(null, h.childs[g_1].id);
                        s.tobj._dragRoutine(m.set("sid", h.childs[g_1].id));
                        if (e != h.childs.length) {
                            g_1--;
                            e = h.childs.length;
                        }
                    }
                }
                m.close();
            }
        }
    }
    if (s.mode == "move") {
        s.sobj[s.source == "tree" ? "deleteItem" : "deleteRow"](s.sid);
        if (s.sobj == s.tobj && !s.tobj.rowsAr[s.sid]) {
            s.tobj.changeRowId(s.nid, s.sid);
            s.nid = s.sid;
        }
    }
};
dhtmlXGridObject.prototype.gridToGrid = function (g, a, e) {
    var h = new Array();
    for (var c = 0; c < a.hdr.rows[0].cells.length; c++) {
        h[c] = a.cells(g, c).getValue();
    }
    return h;
};
dhtmlXGridObject.prototype.checkParentLine = function (a, c) {
    if (!this._h2 || !c || !a) {
        return false;
    }
    if (a.id == c) {
        return true;
    }
    else {
        return this.checkParentLine(a.parent, c);
    }
};
dhtmlXGridObject.prototype._dragIn = function (l, g, c, m) {
    if (!this.dADTempOff) {
        return 0;
    }
    var a = this.isTreeGrid();
    var h = g.parentNode.idd ? g.parentNode : g.parentObject;
    if (this._drag_validate) {
        if (l.parentNode == g.parentNode) {
            return 0;
        }
        if (a &&
            this == h.grid &&
            this.checkParentLine(this._h2.get[l.parentNode.idd], g.parentNode.idd)) {
            return 0;
        }
    }
    if (!this.callEvent("onDragIn", [
        h.idd || h.id,
        l.parentNode.idd,
        h.grid || h.treeNod,
        l.grid || l.parentNode.grid
    ])) {
        return this._setMove(l, c, m, true);
    }
    this._setMove(l, c, m);
    if (a && l.parentNode.expand != "") {
        var e = this;
        this._autoOpenTimer = window.setTimeout(function () {
            e._autoOpenItem(null, e);
            e = null;
        }, 1000);
        this._autoOpenId = l.parentNode.idd;
    }
    else {
        if (this._autoOpenTimer) {
            window.clearTimeout(this._autoOpenTimer);
        }
    }
    return l;
};
dhtmlXGridObject.prototype._autoOpenItem = function (a, c) {
    c.openItem(c._autoOpenId);
};
dhtmlXGridObject.prototype._dragOut = function (c) {
    this._clearMove();
    var a = c.parentNode.parentObject ? c.parentObject.id : c.parentNode.idd;
    this.callEvent("onDragOut", [a]);
    if (this._autoOpenTimer) {
        window.clearTimeout(this._autoOpenTimer);
    }
};
dhtmlXGridObject.prototype._setMove = function (l, c, n, h) {
    if (!l.parentNode.idd) {
        return;
    }
    var e = dhx4.absTop(l);
    var a = dhx4.absTop(this.objBox);
    if (e - a > parseInt(this.objBox.offsetHeight) - 50) {
        this.objBox.scrollTop = parseInt(this.objBox.scrollTop) + 20;
    }
    if (e - a + parseInt(this.objBox.scrollTop) <
        parseInt(this.objBox.scrollTop) + 30) {
        this.objBox.scrollTop = parseInt(this.objBox.scrollTop) - 20;
    }
    if (h) {
        return 0;
    }
    var m = null;
    if (this.dadmode == 2) {
        m =
            n -
                e +
                (document.body.scrollTop || document.documentElement.scrollTop) -
                2 -
                l.offsetHeight / 2;
        if (Math.abs(m) - l.offsetHeight / 6 > 0) {
            this.dadmodec = 1;
            if (m < 0) {
                this.dadmodefix = -1;
            }
            else {
                this.dadmodefix = 1;
            }
        }
        else {
            this.dadmodec = 0;
        }
    }
    else {
        this.dadmodec = this.dadmode;
    }
    if (this.dadmodec) {
        if (!this._sdrgc) {
            this._createSdrgc();
        }
        this._sdrgc.style.display = "block";
        this._sdrgc.style.top =
            e -
                a +
                parseInt(this.objBox.scrollTop) +
                (this.dadmodefix >= 0 ? l.offsetHeight : 0) +
                "px";
    }
    else {
        this._llSelD = l;
        if (l.parentNode.tagName == "TR") {
            for (var g = 0; g < l.parentNode.childNodes.length; g++) {
                m = l.parentNode.childNodes[g];
                m._bgCol = m.style.backgroundColor;
                m.style.backgroundColor = "#FFCCCC";
            }
        }
    }
};
dhtmlXGridObject.prototype._clearMove = function () {
    if (this._sdrgc) {
        this._sdrgc.style.display = "none";
    }
    if (this._llSelD && this._llSelD.parentNode.tagName == "TR") {
        var c = this._llSelD.parentNode.childNodes;
        for (var a = 0; a < c.length; a++) {
            c[a].style.backgroundColor = c[a]._bgCol;
        }
    }
    this._llSelD = null;
};
dhtmlXGridObject.prototype.rowToDragElement = function (a) {
    var c = this.cells(a, 0).getValue();
    return c;
};
dhtmlXGridObject.prototype._copyUserData = function (g) {
    if (!g.tobj.UserData[g.nid] || g.tobj != g.sobj) {
        g.tobj.UserData[g.nid] = new Hashtable();
    }
    else {
        return;
    }
    var e = g.sobj.UserData[g.sid];
    var a = g.tobj.UserData[g.nid];
    if (e) {
        a.keys = a.keys.concat(e.keys);
        a.values = a.values.concat(e.values);
    }
};
dhtmlXGridObject.prototype.moveRow = function (e, g, a, c) {
    switch (g) {
        case "row_sibling":
            this.moveRowTo(e, a, "move", "sibling", this, c);
            break;
        case "up":
            this.moveRowUp(e);
            break;
        case "down":
            this.moveRowDown(e);
            break;
    }
};
dhtmlXGridObject.prototype._nonTrivialNode = function (s, r, m, n, e) {
    if (s.callEvent && !e) {
        if (!s.callEvent("onDrag", [n.idd, r.id, m ? m.id : null, this, s])) {
            return false;
        }
    }
    var o = n.idd;
    var a = o;
    while (s._idpull[a]) {
        a += new Date().getMilliseconds().toString();
    }
    var h = this.isTreeGrid() ? this.getItemImage(o) : "";
    if (m) {
        for (g = 0; g < r.childsCount; g++) {
            if (r.childNodes[g] == m) {
                break;
            }
        }
        if (g != 0) {
            m = r.childNodes[g - 1];
        }
        else {
            m = "";
        }
    }
    var c = s._attachChildNode(r, a, this.gridToTreeElement(s, a, o), "", h, h, h, "", "", m);
    if (this._h2) {
        var l = this._h2.get[o];
        if (l.childs.length) {
            for (var g = 0; g < l.childs.length; g++) {
                this._nonTrivialNode(s, c, 0, this.rowsAr[l.childs[g].id], 1);
                if (!this.dpcpy) {
                    g--;
                }
            }
        }
    }
    if (!this.dpcpy) {
        this.deleteRow(o);
    }
    if (s.callEvent && !e) {
        s.callEvent("onDrop", [a, r.id, m ? m.id : null, this, s]);
    }
};
dhtmlXGridObject.prototype.gridToTreeElement = function (c, e, a) {
    return this.cells(a, 0).getValue();
};
dhtmlXGridObject.prototype.treeToGridElement = function (g, h, a) {
    var c = new Array();
    var l = this.cellType._dhx_find("tree");
    if (l == -1) {
        l = 0;
    }
    for (var e = 0; e < this.getColumnCount(); e++) {
        c[c.length] =
            e != l ? g.getUserData(h, this.getColumnId(e)) || "" : g.getItemText(h);
    }
    return c;
};
dhtmlXGridObject.prototype.moveRowTo = function (g, e, m, l, a, h) {
    var n = new dragContext((a || this).isTreeGrid() ? "treeGrid" : "grid", (h || this).isTreeGrid() ? "treeGrid" : "grid", m, l || "sibling", g, e, a || this, h || this);
    n.tobj._dragRoutine(n);
    n.close();
    return n.nid;
};
dhtmlXGridObject.prototype.enableMercyDrag = function (a) {
    this.dpcpy = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.toPDF = function (g, r, w, u, n, D) {
    var h = {
        row: (this.getSelectedRowId() || "").split(this.delim),
        col: this.getSelectedCellIndex()
    };
    if (h.row === null || h.col === -1) {
        h = false;
    }
    else {
        if (h.row) {
            for (var x = 0; x < h.row.length; x++) {
                if (h.row[x]) {
                    var c = this.cells(h.row[x], h.col).cell;
                    c.parentNode.className = c.parentNode.className.replace(" rowselected", "");
                    c.className = c.className.replace(" cellselected", "");
                    h.row[x] = c;
                }
            }
        }
        else {
            h = false;
        }
    }
    r = r || "color";
    var y = r == "full_color";
    var a = this;
    a._asCDATA = true;
    if (typeof D === "undefined") {
        this.target = ' target="_blank"';
    }
    else {
        this.target = D;
    }
    eXcell_ch.prototype.getContent = function () {
        return this.getValue();
    };
    eXcell_ra.prototype.getContent = function () {
        return this.getValue();
    };
    function C(H) {
        var N = [];
        for (var L = 1; L < a.hdr.rows.length; L++) {
            N[L] = [];
            for (var K = 0; K < a._cCount; K++) {
                var P = a.hdr.rows[L].childNodes[K];
                if (!N[L][K]) {
                    N[L][K] = [0, 0];
                }
                if (P) {
                    N[L][P._cellIndexS] = [P.colSpan, P.rowSpan];
                }
            }
        }
        var M = "<rows profile='" + H + "'";
        if (w) {
            M += " header='" + w + "'";
        }
        if (u) {
            M += " footer='" + u + "'";
        }
        M +=
            "><head>" +
                a
                    ._serialiseExportConfig(N)
                    .replace(/^<head/, "<columns")
                    .replace(/head>$/, "columns>");
        for (var L_1 = 2; L_1 < a.hdr.rows.length; L_1++) {
            var E = 0;
            var T = a.hdr.rows[L_1];
            var O = "";
            for (var K_1 = 0; K_1 < a._cCount; K_1++) {
                if ((a._srClmn && !a._srClmn[K_1]) ||
                    (a._hrrar[K_1] && (!a._fake || K_1 >= a._fake.hdrLabels.length))) {
                    E++;
                    continue;
                }
                var S = N[L_1][K_1];
                var Q = S[0] && S[0] > 1 ? ' colspan="' + S[0] + '" ' : "";
                if (S[1] && S[1] > 1) {
                    Q += ' rowspan="' + S[1] + '" ';
                    E = -1;
                }
                var F = "";
                var J = T;
                if (a._fake && K_1 < a._fake._cCount) {
                    J = a._fake.hdr.rows[L_1];
                }
                for (var I = 0; I < J.cells.length; I++) {
                    if (J.cells[I]._cellIndexS == K_1) {
                        if (J.cells[I].getElementsByTagName("SELECT").length) {
                            F = "";
                        }
                        else {
                            F = dhx4.isIE ? J.cells[I].innerText : J.cells[I].textContent;
                        }
                        F = F.replace(/[ \n\r\t\xA0]+/, " ");
                        break;
                    }
                }
                if (!F || F == " ") {
                    E++;
                }
                O += "<column" + Q + "><![CDATA[" + F + "]]></column>";
            }
            if (E != a._cCount) {
                M += "\n<columns>" + O + "</columns>";
            }
        }
        M += "</head>\n";
        M += o();
        return M;
    }
    function e() {
        var E = [];
        if (n) {
            for (var F = 0; F < n.length; F++) {
                E.push(v(a.getRowIndex(n[F])));
            }
        }
        else {
            for (var F_1 = 0; F_1 < a.getRowsNum(); F_1++) {
                E.push(v(F_1));
            }
        }
        return E.join("\n");
    }
    function o() {
        var H = ["<foot>"];
        if (!a.ftr) {
            return "";
        }
        for (var I = 1; I < a.ftr.rows.length; I++) {
            H.push("<columns>");
            var L = a.ftr.rows[I];
            for (var F = 0; F < a._cCount; F++) {
                if (a._srClmn && !a._srClmn[F]) {
                    continue;
                }
                if (a._hrrar[F] && (!a._fake || F >= a._fake.hdrLabels.length)) {
                    continue;
                }
                for (var E = 0; E < L.cells.length; E++) {
                    var K = "";
                    var J = "";
                    if (L.cells[E]._cellIndexS == F) {
                        K = dhx4.isIE ? L.cells[E].innerText : L.cells[E].textContent;
                        K = K.replace(/[ \n\r\t\xA0]+/, " ");
                        if (L.cells[E].colSpan && L.cells[E].colSpan != 1) {
                            J = " colspan='" + L.cells[E].colSpan + "' ";
                        }
                        if (L.cells[E].rowSpan && L.cells[E].rowSpan != 1) {
                            J = " rowspan='" + L.cells[E].rowSpan + "' ";
                        }
                        break;
                    }
                }
                H.push("<column" + J + "><![CDATA[" + K + "]]></column>");
            }
            H.push("</columns>");
        }
        H.push("</foot>");
        return H.join("\n");
    }
    function m(F, E) {
        return ((window.getComputedStyle
            ? window.getComputedStyle(F, null)[E]
            : F.currentStyle
                ? F.currentStyle[E]
                : null) || "");
    }
    function v(I) {
        if (!a.rowsBuffer[I]) {
            return "";
        }
        var E = a.render_row(I);
        if (E.style.display == "none") {
            return "";
        }
        var F = a.isTreeGrid() ? ' level="' + a.getLevel(E.idd) + '"' : "";
        var M = "<row" + F + ">";
        for (var K = 0; K < a._cCount; K++) {
            if ((!a._srClmn || a._srClmn[K]) &&
                (!a._hrrar[K] || (a._fake && K < a._fake.hdrLabels.length))) {
                var Q = a.cells(E.idd, K);
                if (y) {
                    var J = m(Q.cell, "color");
                    var P = m(Q.cell, "backgroundColor");
                    var O = m(Q.cell, "font-weight") || m(Q.cell, "fontWeight");
                    var L = m(Q.cell, "font-style") || m(Q.cell, "fontStyle");
                    var N = m(Q.cell, "text-align") || m(Q.cell, "textAlign");
                    var H = m(Q.cell, "font-family") || m(Q.cell, "fontFamily");
                    if (P == "transparent" || P == "rgba(0, 0, 0, 0)") {
                        P = "rgb(255,255,255)";
                    }
                    M +=
                        "<cell bgColor='" +
                            P +
                            "' textColor='" +
                            J +
                            "' bold='" +
                            O +
                            "' italic='" +
                            L +
                            "' align='" +
                            N +
                            "' font='" +
                            H +
                            "'>";
                }
                else {
                    M += "<cell>";
                }
                M +=
                    "<![CDATA[" +
                        (Q.getContent ? Q.getContent() : Q.getTitle()) +
                        "]]></cell>";
            }
        }
        return M + "</row>";
    }
    function s() {
        var E = "</rows>";
        return E;
    }
    var A = document.createElement("div");
    A.style.display = "none";
    document.body.appendChild(A);
    var l = "form_" + a.uid();
    A.innerHTML =
        '<form id="' +
            l +
            '" method="post" action="' +
            g +
            '" accept-charset="utf-8"  enctype="application/x-www-form-urlencoded"' +
            this.target +
            '><input type="hidden" name="grid_xml" id="grid_xml"/> </form>';
    document.getElementById(l).firstChild.value = encodeURIComponent(C(r).replace("\u2013", "-") + e() + s());
    document.getElementById(l).submit();
    A.parentNode.removeChild(A);
    a = null;
    if (h && h.row.length) {
        for (var x_1 = 0; x_1 < h.row.length; x_1++) {
            h.row[x_1].parentNode.className += " rowselected";
            if (h.row.length == 1) {
                h.row[x_1].className += " cellselected";
            }
        }
    }
    h = null;
};
dhtmlXGridObject.prototype._serialiseExportConfig = function (l) {
    function h(r) {
        if (typeof r !== "string") {
            return r;
        }
        r = r.replace(/&/g, "&amp;");
        r = r.replace(/"/g, "&quot;");
        r = r.replace(/'/g, "&apos;");
        r = r.replace(/</g, "&lt;");
        r = r.replace(/>/g, "&gt;");
        return r;
    }
    var c = "<head>";
    for (var e = 0; e < this.hdr.rows[0].cells.length; e++) {
        if (this._srClmn && !this._srClmn[e]) {
            continue;
        }
        if (this._hrrar[e] && (!this._fake || e >= this._fake.hdrLabels.length)) {
            continue;
        }
        var g = this.fldSort[e];
        if (g == "cus") {
            g = this._customSorts[e].toString();
            g = g.replace(/function[\ ]*/, "").replace(/\([^\f]*/, "");
        }
        var o = l[1][e];
        var m = (o[1] && o[1] > 1 ? ' rowspan="' + o[1] + '" ' : "") +
            (o[0] && o[0] > 1 ? ' colspan="' + o[0] + '" ' : "");
        c +=
            "<column " +
                m +
                " width='" +
                this.getColWidth(e) +
                "' align='" +
                this.cellAlign[e] +
                "' type='" +
                this.cellType[e] +
                "' hidden='" +
                (this.isColumnHidden && this.isColumnHidden(e) ? "true" : "false") +
                "' sort='" +
                (g || "na") +
                "' color='" +
                (this.columnColor[e] || "") +
                "'" +
                (this.columnIds[e] ? " id='" + this.columnIds[e] + "'" : "") +
                ">";
        if (this._asCDATA) {
            c += "<![CDATA[" + this.getColumnLabel(e) + "]]>";
        }
        else {
            c += this.getColumnLabel(e);
        }
        var n = this.combos[e] ? this.getCombo(e) : null;
        if (n) {
            for (var a = 0; a < n.keys.length; a++) {
                c +=
                    "<option value='" +
                        h(n.keys[a]) +
                        "'><![CDATA[" +
                        n.values[a] +
                        "]]></option>";
            }
        }
        c += "</column>";
    }
    return (c += "</head>");
};
dhtmlXGridObject.prototype.toExcel = function (a, g, m, l, c) {
    if (!document.getElementById("ifr")) {
        var h = document.createElement("iframe");
        h.style.display = "none";
        h.setAttribute("name", "dhx_export_iframe");
        h.setAttribute("src", "");
        h.setAttribute("id", "dhx_export_iframe");
        document.body.appendChild(h);
    }
    var e = ' target="dhx_export_iframe"';
    this.toPDF(a, g, m, l, c, e);
};
dhtmlXGridObject.prototype.filterBy = function (e, g, c) {
    if (this.isTreeGrid()) {
        return this.filterTreeBy(e, g, c);
    }
    if (this._f_rowsBuffer) {
        if (!c) {
            this.rowsBuffer = new dhtmlxArray([].concat(this._f_rowsBuffer));
            if (this._fake) {
                this._fake.rowsBuffer = this.rowsBuffer;
            }
        }
    }
    else {
        this._f_rowsBuffer = [].concat(this.rowsBuffer);
    }
    if (!this.rowsBuffer.length) {
        return;
    }
    var h = true;
    this.dma(true);
    if (typeof e == "object") {
        for (var a = 0; a < g.length; a++) {
            this._filterA(e[a], g[a]);
        }
    }
    else {
        this._filterA(e, g);
    }
    this.dma(false);
    if (this.pagingOn &&
        this.rowsBuffer.length / this.rowsBufferOutSize < this.currentPage - 1) {
        this.changePage(0);
    }
    this._reset_view();
    this.callEvent("onGridReconstructed", []);
};
dhtmlXGridObject.prototype._filterA = function (c, e) {
    if (e == "") {
        return;
    }
    var g = true;
    if (typeof e == "function") {
        g = false;
    }
    else {
        e = (e || "").toString().toLowerCase();
    }
    if (!this.rowsBuffer.length) {
        return;
    }
    for (var a = this.rowsBuffer.length - 1; a >= 0; a--) {
        if (g
            ? this._get_cell_value(this.rowsBuffer[a], c)
                .toString()
                .toLowerCase()
                .indexOf(e) == -1
            : !e.call(this, this._get_cell_value(this.rowsBuffer[a], c), this.rowsBuffer[a].idd)) {
            this.rowsBuffer.splice(a, 1);
        }
    }
};
dhtmlXGridObject.prototype.getFilterElement = function (a) {
    if (!this.filters) {
        return;
    }
    for (var c = 0; c < this.filters.length; c++) {
        if (this.filters[c][1] == a) {
            return this.filters[c][0].combo || this.filters[c][0];
        }
    }
    return null;
};
dhtmlXGridObject.prototype.collectValues = function (g) {
    var v = this.dhxevs.data.oncollectvalues;
    if (v) {
        var r = true;
        for (var s in v) {
            var x = v[s].call(this, g);
            if (x !== true) {
                r = x || r;
            }
        }
        if (r !== true) {
            return r;
        }
    }
    if (this.isTreeGrid()) {
        return this.collectTreeValues(g);
    }
    this.dma(true);
    this._build_m_order();
    g = this._m_order ? this._m_order[g] : g;
    var n = {};
    var l = [];
    var e = this._f_rowsBuffer || this.rowsBuffer;
    for (var h = 0; h < e.length; h++) {
        var a = this._get_cell_value(e[h], g);
        if (a &&
            (!e[h]._childIndexes ||
                e[h]._childIndexes[g] != e[h]._childIndexes[g - 1])) {
            n[a] = true;
        }
    }
    this.dma(false);
    var o = this.combos[g] ||
        (this._col_combos
            ? this._col_combos[g]
            : this._sub_trees && this._sub_trees[g]
                ? this._sub_trees[g][0]
                : false);
    for (var m in n) {
        if (n[m] === true) {
            if (o) {
                if (o.get && o.get(m)) {
                    m = o.get(m);
                }
                else {
                    if (o.getOption && o.getOption(m)) {
                        m = o.getOption(m).text;
                    }
                    else {
                        if (o.getItemText) {
                            var u = o.getItemText(m);
                            var w = (this._sub_trees[g][1] = this._sub_trees[g][1] || {});
                            w[u] = m;
                            m = u;
                        }
                    }
                }
            }
            l.push(m);
        }
    }
    return l.sort();
};
dhtmlXGridObject.prototype._build_m_order = function () {
    if (this._c_order) {
        this._m_order = [];
        for (var a = 0; a < this._c_order.length; a++) {
            this._m_order[this._c_order[a]] = a;
        }
    }
};
dhtmlXGridObject.prototype.filterByAll = function () {
    var e = [];
    var c = [];
    this._build_m_order();
    for (var g = 0; g < this.filters.length; g++) {
        var l = this._m_order
            ? this._m_order[this.filters[g][1]]
            : this.filters[g][1];
        if (l >= this._cCount) {
            continue;
        }
        c.push(l);
        var m = (this.filters[g][0].old_value = this.filters[g][0].value);
        if (this.filters[g][0]._filter) {
            m = this.filters[g][0]._filter();
        }
        var h;
        if (typeof m != "function" &&
            (h =
                this.combos[l] ||
                    (this._col_combos
                        ? this._col_combos[l]
                        : this._sub_trees && this._sub_trees[l]
                            ? this._sub_trees[l][1]
                            : false))) {
            if (h.values) {
                l = h.values._dhx_find(m);
                m = l == -1 ? m : h.keys[l];
            }
            else {
                if (h.getOptionByLabel) {
                    m = h.getOptionByLabel(m) ? h.getOptionByLabel(m).value : m;
                }
                else {
                    m = h[m];
                }
            }
        }
        e.push(m);
    }
    if (!this.callEvent("onFilterStart", [c, e])) {
        return;
    }
    this.filterBy(c, e);
    if (this._cssEven) {
        this._fixAlterCss();
    }
    this.callEvent("onFilterEnd", [this.filters]);
    if (this._f_rowsBuffer &&
        this.rowsBuffer.length == this._f_rowsBuffer.length) {
        this._f_rowsBuffer = null;
    }
};
dhtmlXGridObject.prototype.makeFilter = function (h, e, c) {
    if (!this.filters) {
        this.filters = [];
    }
    if (typeof h != "object") {
        h = document.getElementById(h);
    }
    if (!h) {
        return;
    }
    var a = this;
    if (!h.style.width) {
        h.style.width = "90%";
    }
    if (h.tagName == "SELECT") {
        this.filters.push([h, e]);
        this._loadSelectOptins(h, e);
        h.onchange = function () {
            a.filterByAll();
        };
        if (dhx4.isIE) {
            h.style.marginTop = "1px";
        }
        this.attachEvent("onEditCell", function (m, l, n) {

            this._build_m_order();

            if (m == 2 &&
                this.filters &&
                (this._m_order ? n == this._m_order[e] : n == e)) {

                this._loadSelectOptins(h, e);
            }
            return true;
        });
    }
    else {
        if (h.tagName == "INPUT") {
            this.filters.push([h, e]);
            h.old_value = h.value = "";
            h.style.border="1px solid #dfdfdf";
            h.onkeydown = function () {
                if (this._timer) {
                    window.clearTimeout(this._timer);
                }
                this._timer = window.setTimeout(function () {
                    if (h.value != h.old_value) {
                        a.filterByAll();
                        h.old_value = h.value;
                    }
                }, 500);
            };
        }
    }

    if (h.parentNode) {
        h.parentNode.className += " filter";
        h.parentNode.style.position="relative";
        $(`<span class="searchSpan" style="position: absolute;right: 28px;top:0px;font-size: 18px;cursor: pointer;color:#666;">
                <i class="ivu-icon ivu-icon-ios-search"></i>
                </span>`).appendTo(h.parentNode);

        var gridObj=this;
        $( h.parentNode).find(".ivu-icon").click(function () {
            window.appObj.$bus&&window.appObj.$bus.$emit("cellFilter_"+gridObj.gridId, {cellIndex:e,cellValue:h.value,gridObj:gridObj});
        })
    }
    this._filters_ready();
};
dhtmlXGridObject.prototype.findCell = function (l, m, g, hVal) {
    var h = hVal ||
        function (o, n) {
            return (n
                .toString()
                .toLowerCase()
                .indexOf(o) != -1);
        };
    if (h === true) {
        h = function (o, n) {
            return n.toString().toLowerCase() == o;
        };
    }
    var e = new Array();
    l = l.toString().toLowerCase();
    if (typeof g != "number") {
        g = g ? 1 : 0;
    }
    if (!this.rowsBuffer.length) {
        return e;
    }
    for (var c = m || 0; c < this._cCount; c++) {
        if (this._h2) {
            this._h2.forEachChild(0, function (n) {
                if (g && e.length == g) {
                    return e;
                }

                if (h(l, this._get_cell_value(n.buff, c))) {
                    e.push([n.id, c]);
                }
            }, this);
        }
        else {
            for (var a = 0; a < this.rowsBuffer.length; a++) {
                if (h(l, this._get_cell_value(this.rowsBuffer[a], c))) {
                    e.push([this.rowsBuffer[a].idd, c]);
                    if (g && e.length == g) {
                        return e;
                    }
                }
            }
        }
        if (typeof m != "undefined") {
            return e;
        }
    }
    return e;
};
dhtmlXGridObject.prototype.makeSearch = function (g, e, a) {
    if (typeof g != "object") {
        g = document.getElementById(g);
    }
    if (!g) {
        return;
    }
    var c = this;
    if (g.tagName == "INPUT") {
        g.onkeypress = function () {
            if (this._timer) {
                window.clearTimeout(this._timer);
            }
            this._timer = window.setTimeout(function () {
                if (g.value == "") {
                    return;
                }
                var h = c.findCell(g.value, e, true, a);
                if (h.length) {
                    if (c._h2) {
                        c.openItem(h[0][0]);
                    }
                    c.selectCell(c.getRowIndex(h[0][0]), e || 0);
                }
            }, 500);
        };
    }
    if (g.parentNode) {
        g.parentNode.className += " filter";
    }
};
dhtmlXGridObject.prototype._loadSelectOptins = function (h, n) {
    var a = this.collectValues(n);
    var e = h.value;
    h.innerHTML = "";
    h.options[0] = new Option("", "");
    var m = this._filter_tr ? this._filter_tr[n] : null;
    for (var g = 0; g < a.length; g++) {
        h.options[h.options.length] = new Option(m ? m(a[g]) : a[g], a[g]);
    }
    h.value = e;
};
dhtmlXGridObject.prototype.setSelectFilterLabel = function (c, a) {
    if (!this._filter_tr) {
        this._filter_tr = [];
    }
    this._filter_tr[c] = a;
};
dhtmlXGridObject.prototype._loadComboOptins = function (g, m) {
    if (!g.combo) {
        return;
    }
    var a = this.collectValues(m);
    g.combo.clearAll();
    var h = [["", ""]];
    for (var e = 0; e < a.length; e++) {
        h.push([a[e], a[e]]);
    }
    g.combo.addOption(h);
};
dhtmlXGridObject.prototype.refreshFilters = function () {
    if (!this.filters) {
        return;
    }
    for (var a = 0; a < this.filters.length; a++) {
        switch (this.filters[a][0].tagName.toLowerCase()) {
            case "input":
                break;
            case "select":
                this._loadSelectOptins.apply(this, this.filters[a]);
                break;
            case "div":
                this._loadComboOptins.apply(this, this.filters[a]);
                break;
        }
    }
};
dhtmlXGridObject.prototype._filters_ready = function (c, a) {
    this.attachEvent("onXLE", this.refreshFilters);
    this.attachEvent("onRowCreated", function (h, g) {

        if (this._f_rowsBuffer) {

            for (var e = 0; e < this._f_rowsBuffer.length; e++) {

                if (this._f_rowsBuffer[e].idd == h) {

                    return (this._f_rowsBuffer[e] = g);
                }
            }
        }
    });
    this.attachEvent("onClearAll", function () {

        this._f_rowsBuffer = null;

        if (!this.hdr.rows.length) {

            this.filters = [];
        }
    });
    this.attachEvent("onSetSizes", this._filters_resize_combo);
    this.attachEvent("onResize", this._filters_resize_combo);
    this._filters_ready = function () { };
};
dhtmlXGridObject.prototype._filters_resize_combo = function () {
    if (!this.filters) {
        return;
    }
    for (var a = 0; a < this.filters.length; a++) {
        if (this.filters[a][0].combo != null) {
            this.filters[a][0].combo.setSize(Math.round((this.filters[a][0].offsetWidth * 90) / 100));
        }
    }
    return true;
};
dhtmlXGridObject.prototype._in_header_text_filter = function (c, a) {
    c.innerHTML = "<input type='text'>";
    c.onclick = c.onmousedown = function (g) {
        (g || event).cancelBubble = true;
        return true;
    };
    c.onselectstart = function () {
        return (event.cancelBubble = true);
    };
    this.makeFilter(c.firstChild, a);
};
dhtmlXGridObject.prototype._in_header_text_filter_inc = function (c, a) {
    c.innerHTML = "<input type='text'>";
    c.onclick = c.onmousedown = function (g) {
        (g || event).cancelBubble = true;
        return true;
    };
    c.onselectstart = function () {
        return (event.cancelBubble = true);
    };
    this.makeFilter(c.firstChild, a);
    c.firstChild._filter = function () {
        if (c.firstChild.value == "") {
            return "";
        }
        return function (e) {
            return (e
                .toString()
                .toLowerCase()
                .indexOf(c.firstChild.value.toLowerCase()) == 0);
        };
    };
    this._filters_ready();
};
dhtmlXGridObject.prototype._in_header_select_filter = function (c, a) {
    c.innerHTML = "<select></select>";
    c.onclick = function (g) {
        (g || event).cancelBubble = true;
        return false;
    };
    this.makeFilter(c.firstChild, a);
};
dhtmlXGridObject.prototype._in_header_select_filter_strict = function (e, c) {
    e.innerHTML =
        "<select style='width:90%; font-size:8pt; font-family:Tahoma;'></select>";
    e.onclick = function (g) {
        (g || event).cancelBubble = true;
        return false;
    };
    this.makeFilter(e.firstChild, c);
    var a = this.combos;
    e.firstChild._filter = function () {
        var g = e.firstChild.value;
        if (!g) {
            return "";
        }
        if (a[c]) {
            g = a[c].keys[a[c].values._dhx_find(g)];
        }
        g = g.toLowerCase();
        return function (h) {
            return h.toString().toLowerCase() == g;
        };
    };
    this._filters_ready();
};
dhtmlXGridObject.prototype._in_header_combo_filter = function (c, a) {
    c.innerHTML =
        "<div style='width:100%; padding-left:2px; overflow:hidden; ' class='combo'></div>";
    c.onselectstart = function () {
        return (event.cancelBubble = true);
    };
    c.onclick = c.onmousedown = function (g) {
        (g || event).cancelBubble = true;
        return true;
    };
    this.makeFilter(c.firstChild, a);
};
dhtmlXGridObject.prototype._search_common = function (c, a) {
    c.innerHTML = "<input type='text' style='width:90%; '>";
    c.onclick = c.onmousedown = function (g) {
        (g || event).cancelBubble = true;
        return true;
    };
    c.onselectstart = function () {
        return (event.cancelBubble = true);
    };
};
dhtmlXGridObject.prototype._in_header_text_search = function (e, c, a) {
    this._search_common(e, c);
    this.makeSearch(e.firstChild, c);
};
dhtmlXGridObject.prototype._in_header_text_search_strict = function (c, a) {
    this._search_common(c, a);
    this.makeSearch(c.firstChild, a, true);
};
dhtmlXGridObject.prototype._in_header_numeric_filter = function (c, a) {
    this._in_header_text_filter.call(this, c, a);
    c.firstChild._filter = function () {
        var e = this.value;
        var h;
        var m = "==";
        var g = parseFloat(e.replace("=", ""));
        var l = null;
        if (e) {
            if (e.indexOf("..") != -1) {
                e = e.split("..");
                g = parseFloat(e[0]);
                l = parseFloat(e[1]);
                return function (n) {
                    if (n >= g && n <= l) {
                        return true;
                    }
                    return false;
                };
            }
            h = e.match(/>=|<=|>|</);
            if (h) {
                m = h[0];
                g = parseFloat(e.replace(m, ""));
            }
            return Function("v", " if (v " + m + " " + g + " ) return true; return false;");
        }
        return "";
    };
};
dhtmlXGridObject.prototype._in_header_master_checkbox = function (g, e, h) {
    g.innerHTML = h[0] + "<input type='checkbox' />" + h[1];
    var a = this;
    g.getElementsByTagName("input")[0].onclick = function (l) {
        a._build_m_order();
        var c = a._m_order ? a._m_order[e] : e;
        var m = this.checked ? 1 : 0;
        a.forEachRowA(function (o) {

            var n = this.cells(o, c);
            if (n.isCheckbox() && !n.isDisabled()) {
                n.setValue(m);
                n.cell.wasChanged = true;
            }

            this.callEvent("onEditCell", [1, o, c, m]);

            this.callEvent("onCheckbox", [o, c, m]);

            this.callEvent("onCheck", [o, c, m]);
        });
        (l || event).cancelBubble = true;
    };
};
dhtmlXGridObject.prototype._in_header_stat_total = function (e, a, h) {
    var g = function () {
        var n = 0;

        this._build_m_order();

        var m = this._m_order ? this._m_order[a] : a;

        for (var l = 0; l < this.rowsBuffer.length; l++) {

            var c = parseFloat(this._get_cell_value(this.rowsBuffer[l], m));
            n += isNaN(c) ? 0 : c;
        }

        return this._maskArr[m] ? this._aplNF(n, m) : Math.round(n * 100) / 100;
    };
    this._stat_in_header(e, g, a, h, h);
};
dhtmlXGridObject.prototype._in_header_stat_multi_total = function (h, g, o) {
    var n = o[1].split(":");
    o[1] = "";
    for (var e = 0; e < n.length; e++) {
        n[e] = parseInt(n[e]);
    }
    var l = function () {
        var u = 0;

        for (var s = 0; s < this.rowsBuffer.length; s++) {
            var r = 1;
            for (var c = 0; c < n.length; c++) {

                r *= parseFloat(this._get_cell_value(this.rowsBuffer[s], n[c]));
            }
            u += isNaN(r) ? 0 : r;
        }

        return this._maskArr[g] ? this._aplNF(u, g) : Math.round(u * 100) / 100;
    };
    var a = [];
    for (var m = 0; m < n.length; m++) {
        a[n[m]] = true;
    }
    this._stat_in_header(h, l, a, o, o);
};
dhtmlXGridObject.prototype._in_header_stat_max = function (e, a, h) {
    var g = function () {

        this._build_m_order();

        var l = this._m_order ? this._m_order[a] : a;
        var m = -999999999;

        if (this.getRowsNum() == 0) {
            return "&nbsp;";
        }

        for (var c = 0; c < this.rowsBuffer.length; c++) {

            m = Math.max(m, parseFloat(this._get_cell_value(this.rowsBuffer[c], l)));
        }

        return this._maskArr[a] ? this._aplNF(m, a) : m;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_min = function (e, a, h) {
    var g = function () {

        this._build_m_order();

        var l = this._m_order ? this._m_order[a] : a;
        var m = 999999999;

        if (this.getRowsNum() == 0) {
            return "&nbsp;";
        }

        for (var c = 0; c < this.rowsBuffer.length; c++) {

            m = Math.min(m, parseFloat(this._get_cell_value(this.rowsBuffer[c], l)));
        }

        return this._maskArr[a] ? this._aplNF(m, a) : m;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_average = function (e, a, h) {
    var g = function () {

        this._build_m_order();

        var m = this._m_order ? this._m_order[a] : a;
        var o = 0;
        var n = 0;

        if (this.getRowsNum() == 0) {
            return "&nbsp;";
        }

        for (var l = 0; l < this.rowsBuffer.length; l++) {

            var c = parseFloat(this._get_cell_value(this.rowsBuffer[l], m));
            if (!isNaN(c)) {
                o += c;
                n++;
            }
        }

        return this._maskArr[a]
            ? this._aplNF(o / n, a)
            : Math.round((o / n) * 100) / 100;
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._in_header_stat_count = function (e, a, h) {
    var g = function () {

        return this.getRowsNum();
    };
    this._stat_in_header(e, g, a, h);
};
dhtmlXGridObject.prototype._stat_in_header = function (e, g, a, m) {
    var h = this;
    var l = function () {

        this.dma(true);

        e.innerHTML = (m[0] ? m[0] : "") + g.call(this) + (m[1] ? m[1] : "");

        this.dma(false);

        this.callEvent("onStatReady", []);
    };
    if (!this._stat_events) {
        this._stat_events = [];
        this.attachEvent("onClearAll", function () {

            if (!this.hdr.rows[1]) {

                for (var n = 0; n < this._stat_events.length; n++) {
                    for (var c = 0; c < 4; c++) {

                        this.detachEvent(this._stat_events[n][c]);
                    }
                }

                this._stat_events = [];
            }
        });
    }
    this._stat_events.push([
        this.attachEvent("onGridReconstructed", l),
        this.attachEvent("onXLE", l),
        this.attachEvent("onFilterEnd", l),
        this.attachEvent("onEditCell", function (c, o, n) {
            if (c == 2 && (n == a || (a && a[n]))) {

                l.call(this);
            }
            return true;
        })
    ]);
    e.innerHTML = "";
};
dhtmlXGridObject.prototype.loadCSVFile = function (c, a) {
    this.load(c, a, "csv");
};
dhtmlXGridObject.prototype.enableCSVAutoID = function (a) {
    this._csvAID = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.enableCSVHeader = function (a) {
    this._csvHdr = dhx4.s2b(a);
};
dhtmlXGridObject.prototype.setCSVDelimiter = function (a) {
    this.csv.cell = a;
};
dhtmlXGridObject.prototype._csvAID = true;
dhtmlXGridObject.prototype.loadCSVString = function (a) {
    this.parse(a, "csv");
};
dhtmlXGridObject.prototype.serializeToCSV = function (n) {
    this.editStop();
    if (this._mathSerialization) {
        this._agetm = "getMathValue";
    }
    else {
        if (this._strictText || n) {
            this._agetm = "getTitle";
        }
        else {
            this._agetm = "getValue";
        }
    }
    var l = [];
    if (this._csvHdr) {
        for (var h = 1; h < this.hdr.rows.length; h++) {
            var c = [];
            for (var m_1 = 0; m_1 < this._cCount; m_1++) {
                if (!this._srClmn || this._srClmn[m_1]) {
                    c.push(this.getColumnLabel(m_1, h - 1));
                }
            }
            l.push(this.csvParser.str(c, this.csv.cell, this.csv.row));
        }
    }
    var m = 0;
    var g = this.rowsBuffer.length;
    for (m; m < g; m++) {
        var e = this._serializeRowToCVS(null, m);
        if (e != "") {
            l.push(e);
        }
    }
    return this.csvParser.block(l, this.csv.row);
};
dhtmlXGridObject.prototype._serializeRowToCVS = function (a, o, e, m) {
    var n = new Array();
    if (!a) {
        a = this.render_row(o);
        if (this._fake && !this._fake.rowsAr[a.idd]) {
            this._fake.render_row(o);
        }
    }
    if (!this._csvAID) {
        n[n.length] = a.idd;
    }
    e = e || 0;
    m = m || this._cCount;
    var v = false;
    var g = e;
    while (a.childNodes[e]._cellIndex > g && e) {
        e--;
    }
    for (var s = e; g < m; s++) {
        if (!a.childNodes[s]) {
            break;
        }
        var c = a.childNodes[s]._cellIndex;
        var zxVal = null;
        if ((!this._srClmn || this._srClmn[c]) &&
            (!this._serialize_visible || !this._hrrar[c])) {
            var h = a.childNodes[s];
            var l = this.cells(a.idd, c);
            while (g != c) {
                g++;
                n.push("");
                if (g >= m) {
                    break;
                }
            }
            if (g >= m) {
                break;
            }
            g++;
            if (l.cell) {
                zxVal = l[this._agetm]();
            }
            else {
                zxVal = "";
            }
            if (this._chAttr && l.wasChanged()) {
                v = true;
            }
            n[n.length] = zxVal === null ? "" : zxVal;
            if (this._ecspn && h.colSpan && h.colSpan > 1) {
                h = h.colSpan - 1;
                for (var w = 0; w < h; w++) {
                    n[n.length] = "";
                    g++;
                }
            }
        }
        else {
            g++;
        }
    }
    if (this._onlChAttr && !v) {
        return "";
    }
    return this.csvParser.str(n, this.csv.cell, this.csv.row);
};
dhtmlXGridObject.prototype.toClipBoard = function (a) {
    if (window.clipboardData) {
        window.clipboardData.setData("Text", a);
    }
    else {

        new Clipboard().copy(a);
    }
};
dhtmlXGridObject.prototype.fromClipBoard = function () {
    if (window.clipboardData) {
        return window.clipboardData.getData("Text");
    }
    else {

        return new Clipboard().paste();
    }
};
dhtmlXGridObject.prototype.cellToClipboard = function (e, c) {
    if (!e || (!c && c !== 0)) {
        if (!this.selectedRows[0]) {
            return;
        }
        e = this.selectedRows[0].idd;
        c = this.cell._cellIndex;
    }
    var a = this.cells(e, c);
    this.toClipBoard(((a.getLabel ? a.getLabel() : a.getValue()) || "").toString());
};
dhtmlXGridObject.prototype.updateCellFromClipboard = function (e, c) {
    if (!e || !c) {
        if (!this.selectedRows[0]) {
            return;
        }
        e = this.selectedRows[0].idd;
        c = this.cell._cellIndex;
    }
    var a = this.cells(e, c);
    a[a.setImage ? "setLabel" : "setValue"](this.fromClipBoard());
};
dhtmlXGridObject.prototype.rowToClipboard = function (g) {
    var a = "";
    if (this._mathSerialization) {
        this._agetm = "getMathValue";
    }
    else {
        if (this._strictText) {
            this._agetm = "getTitle";
        }
        else {
            this._agetm = "getValue";
        }
    }
    this._serialize_visible = !this._fake;
    if (g) {
        a = this._serializeRowToCVS(this.getRowById(g));
    }
    else {
        var e = [];
        for (var c = 0; c < this.selectedRows.length; c++) {
            e[e.length] = this._serializeRowToCVS(this.selectedRows[c]);
            a = this.csvParser.block(e, this.csv.row);
        }
    }
    this._serialize_visible = false;
    this.toClipBoard(a);
};
dhtmlXGridObject.prototype.updateRowFromClipboard = function (h) {
    var a = this.fromClipBoard();
    if (!a) {
        return;
    }
    var g = null;
    if (h) {
        g = this.getRowById(h);
    }
    else {
        g = this.selectedRows[0];
    }
    if (!g) {
        return;
    }
    var l = this.csvParser;
    a = l.unblock(a, this.csv.cell, this.csv.row)[0];
    if (!this._csvAID) {
        a.splice(0, 1);
    }
    for (var e = 0; e < a.length; e++) {
        var c = this.cells3(g, e);
        c[c.setImage ? "setLabel" : "setValue"](a[e]);
    }
};
dhtmlXGridObject.prototype.csvParser = {
    block: function (a, c) {
        return a.join(c);
    },
    unblock: function (l, a, h) {
        var g = (l || "").split(h);
        for (var c = 0; c < g.length; c++) {
            g[c] = (g[c] || "").split(a);
        }
        var e = g.length - 1;
        if (g[e].length == 1 && g[e][0] == "") {
            g.splice(e, 1);
        }
        return g;
    },
    str: function (c, a, e) {
        return c.join(a);
    }
};
dhtmlXGridObject.prototype.csvExtParser = {
    _quote: RegExp('"', "g"),
    _quote_esc: RegExp('""', "g"),
    block: function (a, c) {
        return a.join(c);
    },
    unblock: function (n, s, v) {
        var e = [[]];
        var c = 0;
        if (!n) {
            return e;
        }
        var o = /^[ ]*"/;
        var m = /"[ ]*$/;
        var a = new RegExp(".*" + v + ".*$");
        var h = n.split(s);
        for (var g = 0; g < h.length; g++) {
            if (h[g].match(o)) {
                var u = h[g].replace(o, "");
                while (!h[g].match(m)) {
                    g++;
                    u += h[g];
                }

                e[c].push(u.replace(m, "").replace(this._quote_esc, '"'));
            }
            else {
                if (h[g].match(a)) {
                    var l = h[g].indexOf(v);

                    e[c].push(h[g].substr(0, l));
                    c++;
                    e[c] = [];
                    h[g] = h[g].substr(l + 1);
                    g--;
                }
                else {
                    if (h[g] || g != h.length - 1) {

                        e[c].push(h[g]);
                    }
                }
            }
        }
        var r = e.length - 1;
        if (r > 0 && !e[r].length) {
            e.splice(r, 1);
        }
        return e;
    },
    str: function (e, a, g) {
        for (var c = 0; c < e.length; c++) {
            e[c] = '"' + e[c].replace(this._quote, '""') + '"';
        }
        return e.join(a);
    }
};
dhtmlXGridObject.prototype.addRowFromClipboard = function () {
    var a = this.fromClipBoard();
    if (!a) {
        return;
    }
    var e = this.csvParser.unblock(a, this.csv.cell, this.csv.row);
    for (var c = 0; c < e.length; c++) {
        if (e[c]) {
            a = e[c];
            if (!a.length) {
                continue;
            }
            if (this._csvAID) {
                this.addRow(this.getRowsNum() + 2, a);
            }
            else {
                if (this.rowsAr[a[0]]) {
                    a[0] = this.uid();
                }
                this.addRow(a[0], a.slice(1));
            }
        }
    }
};
dhtmlXGridObject.prototype.gridToClipboard = function () {
    this.toClipBoard(this.serializeToCSV());
};
dhtmlXGridObject.prototype.gridFromClipboard = function () {
    var a = this.fromClipBoard();
    if (!a) {
        return;
    }
    this.loadCSVString(a);
};
dhtmlXGridObject.prototype.getXLS = function (m) {
    if (!this.xslform) {
        this.xslform = document.createElement("FORM");
        this.xslform.action = (m || "") + "xls.php";
        this.xslform.method = "post";
        this.xslform.target = dhx4.isIE ? "_blank" : "";
        document.body.appendChild(this.xslform);
        var h = document.createElement("INPUT");
        h.type = "hidden";
        h.name = "csv";
        this.xslform.appendChild(h);
        var g = document.createElement("INPUT");
        g.type = "hidden";
        g.name = "csv_header";
        this.xslform.appendChild(g);
    }
    var n = this.serializeToCSV();
    this.xslform.childNodes[0].value = n;
    var e = [];
    var a = this._cCount;
    for (var c = 0; c < a; c++) {
        e.push(this.getHeaderCol(c));
    }
    e = e.join(",");
    this.xslform.childNodes[1].value = e;
    this.xslform.submit();
};
dhtmlXGridObject.prototype.printView = function (v, e) {
    var r = "<style>TD { font-family:Arial; text-align:center; padding-left:2px;padding-right:2px; } \n td.filter input, td.filter select { display:none; }	\n  </style>";
    var E = null;
    if (this._fake) {
        E = [].concat(this._hrrar);
        for (var D = 0; D < this._fake._cCount; D++) {
            this._hrrar[D] = null;
        }
    }
    var o = document.location.port;
    var s = document.location.hostname;
    r +=
        "<base  href='" +
            (document.location.protocol +
                "//" +
                s +
                (o ? ":" + o : "") +
                document.location.pathname) +
            "'></base>";
    if (!this.parentGrid) {
        r += v || "";
    }
    r += '<table width="100%" border="2px" cellpadding="0" cellspacing="0">';
    var u = Math.max(this.rowsBuffer.length, this.rowsCol.length);
    var n = this._cCount;
    var w = this._printWidth();
    r += '<tr class="header_row_1">';
    for (var D_1 = 0; D_1 < n; D_1++) {
        if (this._hrrar && this._hrrar[D_1]) {
            continue;
        }
        var h = this.hdr.rows[1].cells[this.hdr.rows[1]._childIndexes
            ? this.hdr.rows[1]._childIndexes[parseInt(D_1 + "")]
            : D_1];
        var a = h.colSpan || 1;
        var J = h.rowSpan || 1;
        for (var C = 1; C < a; C++) {
            w[D_1] += w[C];
        }
        r +=
            '<td rowspan="' +
                J +
                '" width="' +
                w[D_1] +
                '%" style="background-color:lightgrey;" colspan="' +
                a +
                '">' +
                this.getHeaderCol(D_1) +
                "</td>";
        D_1 += a - 1;
    }
    r += "</tr>";
    for (var D_2 = 2; D_2 < this.hdr.rows.length; D_2++) {
        if (dhx4.isIE) {
            r +=
                "<tr style='background-color:lightgrey' class='header_row_" + D_2 + "'>";
            var g = this.hdr.rows[D_2].childNodes;
            for (var C_1 = 0; C_1 < g.length; C_1++) {
                if (!this._hrrar || !this._hrrar[g[C_1]._cellIndex]) {
                    r += g[C_1].outerHTML;
                }
            }
            r += "</tr>";
        }
        else {
            r +=
                "<tr class='header_row_" +
                    D_2 +
                    "' style='background-color:lightgrey'>" +
                    (this._fake ? this._fake.hdr.rows[D_2].innerHTML : "") +
                    this.hdr.rows[D_2].innerHTML +
                    "</tr>";
        }
    }
    for (var D_3 = 0; D_3 < u; D_3++) {
        r += "<tr>";
        if (this.rowsCol[D_3] && this.rowsCol[D_3]._cntr) {
            r += this.rowsCol[D_3].innerHTML.replace(/<img[^>]*>/gi, "") + "</tr>";
            continue;
        }
        if (this.rowsCol[D_3] && this.rowsCol[D_3].style.display == "none") {
            continue;
        }
        var m;
        var x;
        if (this.rowsCol[D_3]) {
            m = this.rowsCol[D_3].idd;
        }
        else {
            if (this.rowsBuffer[D_3]) {
                m = this.rowsBuffer[D_3].idd;
            }
            else {
                continue;
            }
        }
        for (var C_2 = 0; C_2 < n; C_2++) {
            if (this._hrrar && this._hrrar[C_2]) {
                continue;
            }
            if (this.rowsAr[m] && this.rowsAr[m].tagName == "TR") {
                var I = this.cells(m, C_2);
                if (I._setState) {
                    x = "";
                }
                else {
                    if (I.getContent) {
                        x = I.getContent();
                    }
                    else {
                        if (I.getImage || I.combo) {
                            x = I.cell.innerHTML;
                        }
                        else {
                            x = I.getValue();
                        }
                    }
                }
            }
            else {
                x = this._get_cell_value(this.rowsBuffer[D_3], C_2);
            }
            var y = this.columnColor[C_2]
                ? "background-color:" + this.columnColor[C_2] + ";"
                : "";
            var A = this.cellAlign[C_2] ? "text-align:" + this.cellAlign[C_2] + ";" : "";
            var F = I.getAttribute("colspan");
            r +=
                '<td style="' +
                    y +
                    A +
                    '" ' +
                    (F ? 'colSpan="' + F + '"' : "") +
                    ">" +
                    (x === "" ? "&nbsp;" : x) +
                    "</td>";
            if (F) {
                C_2 += F - 1;
            }
        }
        r += "</tr>";
        if (this.rowsCol[D_3] && this.rowsCol[D_3]._expanded) {
            var l = this.cells4(this.rowsCol[D_3]._expanded.ctrl);
            if (l.getSubGrid) {
                r +=
                    '<tr><td colspan="' +
                        n +
                        '">' +
                        l.getSubGrid().printView() +
                        "</td></tr>";
            }
            else {
                r +=
                    '<tr><td colspan="' +
                        n +
                        '">' +
                        this.rowsCol[D_3]._expanded.innerHTML +
                        "</td></tr>";
            }
        }
    }
    if (this.ftr) {
        for (var D_4 = 1; D_4 < this.ftr.childNodes[0].rows.length; D_4++) {
            r +=
                "<tr style='background-color:lightgrey'>" +
                    (this._fake ? this._fake.ftr.childNodes[0].rows[D_4].innerHTML : "") +
                    this.ftr.childNodes[0].rows[D_4].innerHTML +
                    "</tr>";
        }
    }
    r += "</table>";
    if (this.parentGrid) {
        return r;
    }
    r += e || "";
    var H = window.open("", "_blank");
    H.document.write(r);
    H.document.write("<script>window.onerror=function(){return true;}</script>");
    H.document.close();
    if (this._fake) {
        this._hrrar = E;
    }
};
dhtmlXGridObject.prototype._printWidth = function () {
    var h = [];
    var g = 0;
    for (var e = 0; e < this._cCount; e++) {
        var a = this.getColWidth(e);
        h.push(a);
        g += a;
    }
    var m = [];
    var c = 0;
    for (var e_1 = 0; e_1 < h.length; e_1++) {
        var l = Math.floor((h[e_1] / g) * 100);
        c += l;
        m.push(l);
    }
    m[m.length - 1] += 100 - c;
    return m;
};
dhtmlXGridObject.prototype.enableBlockSelection = function (e) {
    var blockSelectionEls = document.querySelectorAll(".BlockSelection");
    for (var num = 0; num < blockSelectionEls.length; num++) {
        var el = blockSelectionEls[num];
        if (el != null && el.parentNode != null) {
            el.parentNode.removeChild(el);
        }
    }
    if (typeof this._bs_mode == "undefined") {
        var a = this;
        this.obj.onmousedown = function (g) {
            if (a._bs_mode) {
                a._OnSelectionStart(g || event, this);
            }
            return true;
        };
        this._CSVRowDelimiter = this.csv.row;
        this.attachEvent("onResize", function () {
            a._HideSelection();
            return true;
        });
        this.attachEvent("onGridReconstructed", function () {
            a._HideSelection();
            return true;
        });
        this.attachEvent("onFilterEnd", this._HideSelection);
    }
    if (e === false) {
        this._bs_mode = false;
        return this._HideSelection();
    }
    else {
        this._bs_mode = true;
    }
    if (!window.dhx4.isIPad) {
        var c = (this._clip_area = document.createElement("textarea"));
        c.className = "BlockSelection";
        c.style.cssText =
            "position:absolute; width:1px; height:1px; overflow:hidden; color:transparent; background-color:transparent; bottom:1px; right:1px; border:none;";
        c.onkeydown = function (g) {
            g = g || event;
            if (g.keyCode == 86 && (g.ctrlKey || g.metaKey)) {
                a.pasteBlockFromClipboard();
            }
        };
        document.body.insertBefore(this._clip_area, document.body.firstChild);
        /**
         * 表格点击事件
         */
        goingEvent(this.entBox, "click", function () {
            if (a != null && !a.editor && a._clip_area) {
                a._clip_area.select();
            }
        });
    }
};
dhtmlXGridObject.prototype.forceLabelSelection = function (a) {
    this._strictText = dhx4.s2b(a);
};
/**
 * 根据指定的行“ID和列”索引，选择网格中的块
 * @param start_row	string|number
 * @param start_col	number
 * @param end_row	string|number
 * @param end_column	number
 * myGrid.selectBlock("row1",0,"row5",4);
 */
dhtmlXGridObject.prototype.selectBlock = function (g, e, c, a) {
    e = this.getRowIndex(e);
    a = this.getRowIndex(a);
    this._CreateSelection(e, g);
    this._selectionArea = this._RedrawSelectionPos(this.cells2(e, g).cell, this.cells2(a, c).cell);
    this._ShowSelection();
};
dhtmlXGridObject.prototype._OnSelectionStart = function (e, g) {
    var c = this;
    if (e.button == 2) {
        return;
    }
    var h = e.srcElement || e.target;
    if (this.editor) {
        if (h.tagName && (h.tagName == "INPUT" || h.tagName == "TEXTAREA")) {
            return;
        }
        this.editStop();
    }
    c.setActive(true);
    var m = this.getPosition(this.obj);
    var a = e.clientX -
        m[0] +
        (document.body.scrollLeft ||
            (document.documentElement ? document.documentElement.scrollLeft : 0));
    var l = e.clientY -
        m[1] +
        (document.body.scrollTop ||
            (document.documentElement ? document.documentElement.scrollTop : 0));
    this._CreateSelection(a - 4, l - 4);
    if (h == this._selectionObj) {
        this._HideSelection();
        this._startSelectionCell = null;
    }
    else {
        while (h && (!h.tagName || h.tagName.toLowerCase() != "td")) {
            h = h.parentNode;
        }
        this._startSelectionCell = h;
    }
    if (this._startSelectionCell) {
        if (!this.callEvent("onBeforeBlockSelected", [
            this._startSelectionCell.parentNode.idd,
            this._startSelectionCell._cellIndex
        ])) {
            return (this._startSelectionCell = null);
        }
    }
    this.obj.onmousedown = null;
    this.obj[dhx4.isIE ? "onmouseleave" : "onmouseout"] = function (n) {
        if (c._blsTimer) {
            window.clearTimeout(c._blsTimer);
        }
    };
    this.obj.onmmold = this.obj.onmousemove;
    this._init_pos = [a, l];
    this._selectionObj.onmousemove = this.obj.onmousemove = function (n) {
        n = n || e;
        if (n.preventDefault) {
            n.preventDefault();
        }
        else {
            n.returnValue = false;
        }
        c._OnSelectionMove(n);
    };
    this._oldDMP = document.body.onmouseup;
    document.body.onmouseup = function (n) {
        n = n || e;
        c._OnSelectionStop(n, this);
        return true;
    };
    this.callEvent("onBeforeBlockSelection", []);
    document.body.onselectstart = function () {
        return false;
    };
};
dhtmlXGridObject.prototype._getCellByPos = function (a, g) {
    if (this._fake) {
        a += this._fake.objBox.scrollWidth;
    }
    var c = 0;
    for (var e = 0; e < this.obj.rows.length; e++) {
        g -= this.obj.rows[e].offsetHeight;
        if (g <= 0) {
            c = this.obj.rows[e];
            break;
        }
    }
    if (!c || !c.idd) {
        return null;
    }
    for (var e_2 = 0; e_2 < this._cCount; e_2++) {
        a -= this.getColWidth(e_2);
        if (a <= 0) {
            while (true) {
                if (c._childIndexes && c._childIndexes[e_2 + 1] == c._childIndexes[e_2]) {
                    c = c.previousSibling;
                }
                else {
                    return this.cells(c.idd, e_2).cell;
                }
            }
        }
    }
    return null;
};
dhtmlXGridObject.prototype._OnSelectionMove = function (g) {
    var x = this;
    this._ShowSelection();
    var s = this.getPosition(this.obj);
    var m = g.clientX -
        s[0] +
        (document.body.scrollLeft ||
            (document.documentElement ? document.documentElement.scrollLeft : 0));
    var l = g.clientY -
        s[1] +
        (document.body.scrollTop ||
            (document.documentElement ? document.documentElement.scrollTop : 0));
    if (Math.abs(this._init_pos[0] - m) < 5 &&
        Math.abs(this._init_pos[1] - l) < 5) {
        return this._HideSelection();
    }
    var v = this._endSelectionCell;
    if (this._startSelectionCell == null) {
        this._endSelectionCell = this._startSelectionCell = this.getFirstParentOfType(g.srcElement || g.target, "TD");
    }
    else {
        if (g.srcElement || g.target) {
            if ((g.srcElement || g.target).className == "dhtmlxGrid_selection") {
                this._endSelectionCell =
                    this._getCellByPos(m, l) || this._endSelectionCell;
            }
            else {
                var w = this.getFirstParentOfType(g.srcElement || g.target, "TD");
                if (w.parentNode.idd) {
                    this._endSelectionCell = w;
                }
            }
        }
    }
    if (this._endSelectionCell) {
        if (!this.callEvent("onBeforeBlockSelected", [
            this._endSelectionCell.parentNode.idd,
            this._endSelectionCell._cellIndex
        ])) {
            this._endSelectionCell = v;
        }
    }
    var h = this.objBox.scrollLeft + this.objBox.clientWidth;
    var c = this.objBox.scrollTop + this.objBox.clientHeight;
    var o = this.objBox.scrollLeft;
    var n = this.objBox.scrollTop;
    var e = false;
    if (this._blsTimer) {
        window.clearTimeout(this._blsTimer);
    }
    if (m + 20 >= h) {
        this.objBox.scrollLeft = this.objBox.scrollLeft + 20;
        e = true;
    }
    else {
        if (m - 20 < o) {
            this.objBox.scrollLeft = this.objBox.scrollLeft - 20;
            e = true;
        }
    }
    if (l + 20 >= c && !this._realfake) {
        this.objBox.scrollTop = this.objBox.scrollTop + 20;
        e = true;
    }
    else {
        if (l - 20 < n && !this._realfake) {
            this.objBox.scrollTop = this.objBox.scrollTop - 20;
            e = true;
        }
    }
    this._selectionArea = this._RedrawSelectionPos(this._startSelectionCell, this._endSelectionCell);
    if (e) {
        var u = g.clientX;
        var r = g.clientY;
        this._blsTimer = window.setTimeout(function () {
            x._OnSelectionMove({ clientX: u, clientY: r });
        }, 100);
    }
};
dhtmlXGridObject.prototype._OnSelectionStop = function (c) {
    var a = this;
    if (this._blsTimer) {
        window.clearTimeout(this._blsTimer);
    }
    this.obj.onmousedown = function (g) {
        if (a._bs_mode) {
            a._OnSelectionStart(g || c, this);
        }
        return true;
    };
    this.obj.onmousemove = this.obj.onmmold || null;
    this._selectionObj.onmousemove = null;
    document.body.onmouseup = this._oldDMP || null;
    if (parseInt(this._selectionObj.style.width) < 2 &&
        parseInt(this._selectionObj.style.height) < 2) {
        this._HideSelection();
    }
    else {
        var e = this.getFirstParentOfType(c.srcElement || c.target, "TD");
        if (!e || !e.parentNode.idd) {
            e = this._endSelectionCell;
        }
        while (e && (!e.tagName || e.tagName.toLowerCase() != "td")) {
            e = e.parentNode;
        }
        if (!e) {
            return this._HideSelection();
        }
        this._stopSelectionCell = e;
        this._selectionArea = this._RedrawSelectionPos(this._startSelectionCell, this._stopSelectionCell);
        this.callEvent("onBlockSelected", []);
    }
    document.body.onselectstart = function () { };
};
dhtmlXGridObject.prototype._RedrawSelectionPos = function (u, m) {
    if (u.parentNode.grid != m.parentNode.grid) {
        return this._selectionArea;
    }
    var r = {};
    r.LeftTopCol = u._cellIndex;
    r.LeftTopRow = this.getRowIndex(u.parentNode.idd);
    r.RightBottomCol = m._cellIndex;
    r.RightBottomRow = this.getRowIndex(m.parentNode.idd);
    var g = u.offsetWidth;
    var e = u.offsetHeight;
    u = this.getPosition(u, this.obj);
    var v = m.offsetWidth;
    var n = m.offsetHeight;
    m = this.getPosition(m, this.obj);
    var o, h, s, a, l = null;
    if (u[0] < m[0]) {
        h = u[0];
        l = m[0] + v;
    }
    else {
        o = r.RightBottomCol;
        r.RightBottomCol = r.LeftTopCol;
        r.LeftTopCol = o;
        h = m[0];
        l = u[0] + g;
    }
    if (u[1] < m[1]) {
        s = u[1];
        a = m[1] + n;
    }
    else {
        o = r.RightBottomRow;
        r.RightBottomRow = r.LeftTopRow;
        r.LeftTopRow = o;
        s = m[1];
        a = u[1] + e;
    }
    var w = l - h;
    var c = a - s;
    this._selectionObj.style.left = h + "px";
    this._selectionObj.style.top = s + "px";
    this._selectionObj.style.width = w + "px";
    this._selectionObj.style.height = c + "px";
    return r;
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridMethods00.js